import * as React from 'react';

function SvgEmailStroke(props) {
  return (
    <svg
      width="1em"
      height="1em"
      viewBox="0 0 30 30"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
    >
      <path
        fillRule="evenodd"
        clipRule="evenodd"
        d="M22.508 10.123L15 15.815l-7.508-5.692h15.016zm2.074-1.4H5.385a.7.7 0 00-.7.7v12.692a.7.7 0 00.7.7h19.23a.7.7 0 00.7-.7V9.423a.7.7 0 00-.7-.7h-.018a.72.72 0 00-.015 0zm-.667 2.09l-8.492 6.438a.7.7 0 01-.846 0l-8.492-6.438v10.602h17.83V10.813z"
        fill="#414B56"
      />
    </svg>
  );
}

export default SvgEmailStroke;
